module.exports = __webpack_public_path__ + "static/assets/0a04b7481bd2abec00cc952c449d0579.jpg";